import React from 'react';
import Create from '../../../create';
import { useParams } from 'react-router-dom';

export default function BookParcel() {
  const schema = [
    {
      tabName: 'Area',
      editFields: [
        {
          label: 'Area Name',
          name: 'name',
          type: 'text',
        },
      ],
    },
  ];
  const { id }: any = useParams();

  return (
    <Create return="/dashboard/area" url={`${process.env.REACT_APP_API_SERVER}/areas`} dataID={id} schema={schema} />
  );
}
